// action - state management
import {
  ADMIN_LOADED,
  AUTH_FAIL,
  LOGIN_SUCCESS,
  LOGOUT_SUCCESS,
} from "./actions";

// ==============================|| ACCOUNT REDUCER ||============================== //

const initialState = {
  token: localStorage.getItem("AdminAppToken"),
  isAuthenticated: false,
  loading: true,
  admin: {},
};

// const accountReducer = (state = initialState, action) => {
export default function accountReducer(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case LOGIN_SUCCESS:
      localStorage.setItem("AdminAppToken", payload.token);

      return {
        ...state,
        ...payload,
        isAuthenticated: true,
        loading: false,
      };
    case ADMIN_LOADED:
      localStorage.setItem("role", payload.role);
      localStorage.setItem("adminId", payload._id);
      return {
        ...state,
        isAuthenticated: true,
        loading: false,
        admin: payload,
      };
    case LOGOUT_SUCCESS:
      localStorage.removeItem("AdminAppToken");
      localStorage.removeItem("role");
      // localStorage.removeItem("i18nextLng");
      return {
        ...state,
        token: null,
        isAuthenticated: false,
        loading: false,
      };
    case AUTH_FAIL:
      localStorage.removeItem("AdminAppToken");
      return {
        ...state,
        token: null,
        isAuthenticated: false,
        loading: false,
      };
    default:
      return state;
  }
}

// export default accountReducer;
